import { FC } from 'react';
import { HStack } from '@chakra-ui/react';

import SunshineTag from 'components/_core/SunshineTag';
import Tooltip from 'components/_core/Tooltip';

import dashboardLocales from '../../../common/locales';

interface BetaTagProps {
  showTooltip?: boolean;
}
export const BetaTag: FC<BetaTagProps> = ({ showTooltip = false }) => {
  if (!showTooltip) {
    return (
      <SunshineTag colorScheme="green" size="sm">
        {dashboardLocales.beta.tag}
      </SunshineTag>
    );
  }
  return (
    <Tooltip
      closeOnClick={false}
      description={dashboardLocales.beta.dataTooltip}
      placement="bottom"
    >
      <HStack>
        <SunshineTag colorScheme="green" size="sm">
          {dashboardLocales.beta.tag}
        </SunshineTag>
      </HStack>
    </Tooltip>
  );
};
